import { FC} from 'react';
import { createCompanies } from '../../../fetch/imports';
import { UploadHandler } from '../../../components/import/uploadHandler';

export const ImportCompanies: FC = () => {
  return (
  <UploadHandler 
    title='Import Companies'
    loaderMessage='Importing Companies ...'
    createEndpoint={createCompanies}/>
    )
};